import React from "react";
import PurchaseOrders from "@/pages/PurchaseOrders";

export default function Purchase() {
  return <PurchaseOrders mode="pending" />;
}
